import { useEffect, useState } from "react";
import api from "../../../../api";


const NewNotifications = () => {
    const [newNotifications, setNewNotifications] = useState([]);
    const [newNotificationsCount, setNewNotificationsCount] = useState(0);


    useEffect(() => {
        const fetchNewNotifications = async () => {
            try{
                const response = await api.get('/seller/notifications/new?offset=0&limit=10');
                setNewNotifications(response.data.data);
                setNewNotificationsCount(response.data.count);
            } catch(err){
                console.log("Greška pri učitavanju novih obaveštenja, ", err);
            }
        };
        fetchNewNotifications();
    }, [])
  return (
        <div>
            <div>
                <h5 style={styles.header}>Nova obaveštenja ({newNotificationsCount})</h5>
            </div>
            <div>
                {newNotifications.length > 0 ? (
                newNotifications.map((notification) => (
                    <div key={notification.system_message_id}>
                    <p>{notification.message}</p>
                    </div>
                ))
                ) : (
                <p>Nema novih obaveštenja.</p>
                )}
            </div>
        </div>
    );
};

const styles = {
    header : {
        fontSize : "24px",
        color: 'rgba(0, 0, 0, 0.87)',
        fontWeight : "bold",
        marginTop : "39px",
    }
}

export default NewNotifications;
